export default function Books() {
  const books = [
    {
      id: 1,
      title: "The Journey Begins",
      year: "2023",
      description: "A collection of early reflections on life's turning points and the wisdom gained from experience.",
      cover: "https://public.readdy.ai/ai/img_res/963b321b49420f880feff274b6c34cd8.jpg",
      featured: false
    },
    {
      id: 2,
      title: "We All Make Decisions: May Seem Small But They Will Affect You As Minor And Major In Every Way",
      year: "2025",
      description: "A profound exploration of how our choices, both big and small, create lasting impacts on our lives and the lives of those around us. Through personal stories and thoughtful analysis, this book guides readers toward more intentional decision-making.",
      cover: "https://readdy.ai/api/search-image?query=Book%20cover%20We%20All%20Make%20Decisions%20by%20Gary%20Wilson%20bold%20red%20background%20white%20text%20typography%20focused%20design%20professional%20published%20book%20cover%20clean%20modern%20layout%20impactful%20visual%20simple%20elegant%20composition&width=400&height=600&seq=book-cover-decisions-main-001&orientation=portrait",
      featured: true,
      amazonLink: "https://www.amazon.com/We-All-Make-Decisions-Affect/dp/1968970827"
    },
    {
      id: 3,
      title: "Reflections on Responsibility",
      year: "2026",
      description: "An upcoming work exploring the deeper meanings of accountability and how our actions shape the world.",
      cover: "https://readdy.ai/api/search-image?query=Book%20cover%20design%20contemplative%20theme%20mirror%20reflection%20concept%20abstract%20geometric%20shapes%20sophisticated%20color%20palette%20navy%20blue%20gold%20accents%20modern%20minimalist%20typography%20professional%20literary%20work%20elegant%20composition&width=400&height=600&seq=book-cover-reflections-001&orientation=portrait",
      featured: false
    }
  ];

  return (
    <section id="books" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-start justify-between mb-16">
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              PUBLISHED<br />WORKS
            </h2>
          </div>
          <div className="max-w-md">
            <p className="text-gray-600 text-base leading-relaxed">
              A collection of thoughtful explorations into the human experience, each book offering unique insights into the decisions that shape our lives and the wisdom we gain along the way.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
          {books.map((book) => (
            <div 
              key={book.id}
              className={`bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${book.featured ? 'md:scale-105' : ''}`}
            >
              <div className="mb-6 rounded-lg overflow-hidden shadow-lg">
                <img 
                  src={book.cover}
                  alt={book.title}
                  className="w-full h-96 object-cover object-top"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight">
                {book.title}
              </h3>
              <p className="text-sm text-amber-600 font-medium mb-3">{book.year}</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {book.description}
              </p>
              {book.amazonLink ? (
                <a 
                  href={book.amazonLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-amber-700 text-sm font-medium hover:text-amber-800 transition-colors whitespace-nowrap"
                >
                  VIEW ON AMAZON
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              ) : (
                <button className="text-amber-700 text-sm font-medium hover:text-amber-800 transition-colors whitespace-nowrap">
                  VIEW DETAILS
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}